// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b883f207","455":"6191f829"}[chunkId] + ".chunk.js";
};